import Vue from 'vue'
import Vuex from 'vuex'
// eslint-disable-next-line import/no-cycle
import auth from './modules/auth'
import cashRegisters from './modules/cashRegisters'
import positions from './modules/positions'
import halykQr from './modules/halykQr'
import m4bank from './modules/m4bank'
import moyUchet from './modules/moyUchet'
import printer from './modules/printer'
import tools from './modules/tools'
import confirm from './modules/confirm'
import analytics from './modules/analytics'
import miniapp from './modules/miniapp'
import dialogQueue from './modules/dialogQueue'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    cashRegisters,
    positions,
    m4bank,
    halykQr,
    moyUchet,
    printer,
    tools,
    confirm,
    analytics,
    miniapp,
    dialogQueue,
  },
})
